export default __webpack_public_path__ + "static/media/team.cd84d2be.svg";